'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTracker = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getTracker = exports.getTracker = (0, _getIn2.default)(['tracker']);


//////////////////
// WEBPACK FOOTER
// ./js/usage-tracking/selectors/getTracker.js
// module id = 760
// module chunks = 2 3